import { cmsApi } from '@commerce-webcomponents/sdk';
import { Logger } from '@nextgen-web-framework/core';
import { defaultApiErrorHandler } from './helper';

export const fetchCmsContent = async (contentType: string, apiErrorHandler = defaultApiErrorHandler) => {
  const loggerInstance = Logger.getInstance();
  try {
    const data = await apiErrorHandler(() =>
      cmsApi.fetchContent({
        uId: contentType,
      }),
    );
    return data;
  } catch (error) {
    loggerInstance.log('Error fetching content:', error);
    throw error;
  }
};
